<template>
  <div>
    <v-card>
      <v-card-title>
        <v-btn icon @click="$router.push('/admin/content-campaigns')"><v-icon>mdi-arrow-left</v-icon></v-btn>
        Influencer'lar
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined class="mr-2" :loading="importing" @click="$refs.mgrFile.click()"
               title="Excel: 1. kolon Instagram, 2. kolon yönetici e-postası (sistemdeki admin kullanıcı ile eşleşir).">
          <v-icon left>mdi-account-arrow-up</v-icon> Yönetici ata (Excel)
        </v-btn>
        <input ref="mgrFile" type="file" accept=".xlsx" class="d-none" @change="onManagerFile" />
        <v-btn color="primary" outlined class="mr-2" :loading="importing" @click="$refs.shareFile.click()"
               title="Excel: 1. kolon Instagram, 2. kolon kişiye özel paylaşım linki. Link, içerik onaylandıktan sonra influencer'a gösterilir.">
          <v-icon left>mdi-link-plus</v-icon> Paylaşım linki (Excel)
        </v-btn>
        <input ref="shareFile" type="file" accept=".xlsx" class="d-none" @change="onShareLinkFile" />
        <v-btn color="primary" outlined class="mr-2" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Excel
        </v-btn>
        <v-btn color="primary" outlined @click="downloadZip()">
          <v-icon left>mdi-folder-zip</v-icon> Tümünü indir
        </v-btn>
      </v-card-title>

      <v-card-text class="pb-0 d-flex" style="gap: 16px; flex-wrap: wrap;">
        <v-text-field
          v-model="search"
          label="Influencer ara (ad / Instagram)"
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          outlined
          hide-details
          style="max-width: 320px;"
        ></v-text-field>
        <v-select
          v-if="managerOptions.length"
          v-model="managerFilter"
          :items="managerOptions"
          label="Operasyon yöneticisi"
          clearable
          dense
          outlined
          hide-details
          style="max-width: 320px;"
        ></v-select>
      </v-card-text>

      <v-card-text class="py-0">
        <v-chip-group v-model="statusFilter" column>
          <v-chip filter outlined :value="null">Tümü ({{ scopedItems.length }})</v-chip>
          <v-chip v-for="s in statusOptions" :key="s" filter outlined :value="s" :color="statusColor(s)">
            {{ statusText(s) }} ({{ countByStatus(s) }})
          </v-chip>
        </v-chip-group>
      </v-card-text>

      <v-data-table :headers="headers" :items="filteredItems" :loading="loading" :items-per-page="25" @click:row="openRow" style="cursor: pointer;">
        <template v-slot:item.instagramHandle="{ item }">
          <a v-if="isUrl(item.instagramHandle)" :href="item.instagramHandle" target="_blank" @click.stop>{{ igLabel(item.instagramHandle) }}</a>
          <span v-else>@{{ item.instagramHandle }}</span>
        </template>
        <template v-slot:item.operationManagerName="{ item }">
          <span v-if="item.operationManagerName">{{ item.operationManagerName }}</span>
          <span v-else class="grey--text caption">—</span>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip small :color="statusColor(item.status)" dark>{{ statusText(item.status) }}</v-chip>
        </template>
        <template v-slot:item.submissions="{ item }">
          <div class="d-flex py-2" style="gap: 8px; flex-wrap: wrap;">
            <div v-for="s in item.submissions" :key="s.id" class="text-center">
              <video v-if="isVideo(s.fileUrl)" :src="s.fileUrl" class="preview-thumb" muted></video>
              <img v-else :src="s.fileUrl" class="preview-thumb" />
              <div class="caption grey--text">{{ typeText(s.type) }}</div>
            </div>
            <span v-if="!item.submissions || !item.submissions.length" class="grey--text caption">—</span>
          </div>
        </template>
        <template v-slot:item.postUrl="{ item }">
          <a v-if="item.postUrl" :href="item.postUrl" target="_blank">link</a>
        </template>
        <template v-slot:item.shareUrl="{ item }">
          <a v-if="item.shareUrl" :href="item.shareUrl" target="_blank" @click.stop>link</a>
          <span v-else class="grey--text caption">—</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <template v-if="item.status === 1">
            <v-btn x-small color="success" class="mr-1" @click.stop="approve(item)">Onayla</v-btn>
            <v-btn x-small color="warning" @click.stop="openRevision(item)">Revizyon</v-btn>
          </template>
          <v-btn icon small @click.stop="copyLink(item)" title="Özel linki kopyala"><v-icon small>mdi-link-variant</v-icon></v-btn>
          <v-btn icon small @click.stop="downloadZip(item.id)" title="Bu kişinin dosyaları"><v-icon small>mdi-download</v-icon></v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Satır detay: influencer içerikleri (yan yana önizleme) -->
    <v-dialog v-model="rowDialog" max-width="1040" scrollable>
      <v-card v-if="row">
        <v-card-title>
          <a v-if="isUrl(row.instagramHandle)" :href="row.instagramHandle" target="_blank">{{ igLabel(row.instagramHandle) }}</a>
          <span v-else>@{{ row.instagramHandle }}</span>
          <v-chip small :color="statusColor(row.status)" dark class="ml-3">{{ statusText(row.status) }}</v-chip>
          <v-spacer></v-spacer>
          <v-btn icon @click="rowDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-subtitle>
          {{ row.email }}
          <a v-if="row.draftUrl" :href="row.draftUrl" target="_blank" class="ml-3">Taslak linki ↗</a>
          <a v-if="row.postUrl" :href="row.postUrl" target="_blank" class="ml-3">Gönderi linki ↗</a>
          <a v-if="row.shareUrl" :href="row.shareUrl" target="_blank" class="ml-3">Paylaşım linki ↗</a>
          <v-btn x-small text color="primary" class="ml-3" @click="copyLink(row)">
            <v-icon x-small left>mdi-link-variant</v-icon>Özel linki kopyala
          </v-btn>
        </v-card-subtitle>

        <v-card-text>
          <div v-if="row.revisionNote" class="mb-4 pa-3" style="background:#fff3e0; border-radius:8px;">
            <strong>Revizyon notu:</strong> {{ row.revisionNote }}
          </div>

          <div v-if="!row.submissions || !row.submissions.length" class="grey--text text-center py-10">
            Henüz içerik yüklenmedi.
          </div>

          <div v-else class="d-flex" style="gap:20px;">
            <!-- Sol: thumbnail listesi -->
            <div style="width:200px; flex:0 0 200px;">
              <div v-for="grp in groupedSubmissions(row)" :key="grp.type" class="mb-4">
                <div class="overline grey--text mb-1">{{ typeText(grp.type) }}</div>
                <div class="d-flex" style="gap:8px; flex-wrap:wrap;">
                  <div v-for="s in grp.items" :key="s.id" @click="selected = s"
                       :class="['thumb-pick', selected && selected.id === s.id ? 'thumb-pick--active' : '']">
                    <video v-if="isVideo(s.fileUrl)" :src="s.fileUrl" muted></video>
                    <img v-else :src="s.fileUrl" />
                    <v-btn class="thumb-del" icon x-small dark @click.stop="deleteSubmission(s)" title="Sil">
                      <v-icon x-small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sağ: büyük önizleme -->
            <div style="flex:1 1 auto; min-width:0;" class="text-center">
              <div v-if="selected" class="preview-pane">
                <video v-if="isVideo(selected.fileUrl)" :src="selected.fileUrl" controls autoplay></video>
                <img v-else :src="selected.fileUrl" />
              </div>
              <div v-if="selected" class="mt-2">
                <span class="caption grey--text">{{ typeText(selected.type) }}</span>
                <v-btn x-small text color="primary" :href="selected.fileUrl" target="_blank">
                  <v-icon x-small left>mdi-open-in-new</v-icon>Tam boy
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn text color="primary" @click="downloadZip(row.id)"><v-icon left>mdi-download</v-icon>Dosyaları indir</v-btn>
          <v-select
            :value="row.status"
            :items="statusSelectItems"
            label="Durumu değiştir"
            dense
            outlined
            hide-details
            style="max-width: 200px;"
            class="ml-4"
            @change="changeStatus(row, $event)"
          ></v-select>
          <v-spacer></v-spacer>
          <template v-if="row.status === 1">
            <v-btn color="warning" text @click="openRevision(row)">Revizyon</v-btn>
            <v-btn color="success" @click="approve(row)">Onayla</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="revDialog" max-width="480">
      <v-card>
        <v-card-title>Revizyon talebi</v-card-title>
        <v-card-text>
          <v-textarea v-model="revNote" label="Değişiklik notu" rows="4" autofocus></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="revDialog = false">İptal</v-btn>
          <v-btn color="warning" :loading="saving" @click="sendRevision">Gönder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import NucleusComponentBase from "@/shared/application/nucleus-component-base";
import { Component } from "vue-property-decorator";

@Component
export default class ContentCampaignInfluencers extends NucleusComponentBase {
  loading = true;
  saving = false;
  importing = false;
  items: any[] = [];
  managers: string[] = [];
  managerFilter: string | null = null;
  search = "";
  revDialog = false;
  revNote = "";
  current: any = null;
  rowDialog = false;
  row: any = null;
  selected: any = null;
  statusFilter: number | null = null;
  statusOptions = [0, 1, 2, 3, 4, 5];

  // Statü hariç tüm filtreler (yönetici + arama) uygulanmış liste.
  // Statü sayıları ve "Tümü" bu kapsama göre hesaplanır.
  get scopedItems(): any[] {
    const q = (this.search || "").trim().toLowerCase();
    return this.items.filter((x) => {
      const managerOk = !this.managerFilter || x.operationManagerName === this.managerFilter;
      const searchOk =
        !q ||
        (x.instagramHandle || "").toLowerCase().includes(q) ||
        (x.email || "").toLowerCase().includes(q);
      return managerOk && searchOk;
    });
  }

  get filteredItems(): any[] {
    return this.scopedItems.filter(
      (x) => this.statusFilter === null || this.statusFilter === undefined || x.status === this.statusFilter
    );
  }

  get managerOptions(): string[] {
    return this.managers;
  }

  get statusSelectItems(): any[] {
    return this.statusOptions.map((s) => ({ value: s, text: this.statusText(s) }));
  }

  countByStatus(s: number): number {
    return this.scopedItems.filter((x) => x.status === s).length;
  }

  headers = [
    { text: "Instagram", value: "instagramHandle" },
    { text: "Email", value: "email" },
    { text: "Yönetici", value: "operationManagerName" },
    { text: "Durum", value: "status" },
    { text: "Dosyalar", value: "submissions", sortable: false },
    { text: "Gönderi", value: "postUrl", sortable: false },
    { text: "Paylaşım linki", value: "shareUrl", sortable: false },
    { text: "", value: "actions", sortable: false, align: "end" },
  ];

  get campaignId(): string {
    return this.$route.params.id;
  }

  refreshTimer: any = null;

  mounted() {
    this.load();
    // Tabloyu arka planda periyodik yenile (onay/revizyon çakışmasını önlemek için).
    this.refreshTimer = setInterval(() => this.silentRefresh(), 15000);
  }

  beforeDestroy() {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
  }

  async load() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  }

  // Spinner göstermeden, açık işlemleri bozmadan sessiz yenileme.
  async silentRefresh() {
    if (this.revDialog || this.saving || this.importing) return; // revizyon yazarken/işlem sürerken dokunma
    await this.fetchData();
    // Açık detay dialog'undaki satırı güncel haliyle eşitle (durum chip'i tazelensin).
    if (this.rowDialog && this.row) {
      const fresh = this.items.find((x) => x.id === this.row.id);
      if (fresh) this.row = fresh;
    }
  }

  async fetchData() {
    const res = await this.nucleusService.get<any>(`/api/ContentCampaigns/${this.campaignId}/influencers`, false);
    if (!res.isError) this.items = res.content || [];
    const mgr = await this.nucleusService.get<string[]>(`/api/ContentCampaigns/${this.campaignId}/managers`, false);
    if (!mgr.isError) this.managers = mgr.content || [];
  }

  async onManagerFile(e: any) {
    const file = e.target.files && e.target.files[0];
    e.target.value = ""; // aynı dosya tekrar seçilebilsin
    if (!file) return;
    this.importing = true;
    const form = new FormData();
    form.append("file", file);
    const res = await this.nucleusService.postExcel<any>(`/api/ContentCampaigns/${this.campaignId}/managers/import`, form);
    this.importing = false;
    if (!res.isError) {
      const r = res.content || {};
      const extra = `${r.unknownManagers ? ` · ${r.unknownManagers} yönetici bulunamadı` : ""}${r.skipped ? ` · ${r.skipped} satır atlandı` : ""}`;
      this.swalToast(4000, "success", `${r.imported} eşleştirme · ${r.matchedInfluencers} influencer eşleşti${extra}`);
      this.load();
    } else {
      this.swalToast(2500, "error", "Excel yüklenemedi");
    }
  }

  async onShareLinkFile(e: any) {
    const file = e.target.files && e.target.files[0];
    e.target.value = ""; // aynı dosya tekrar seçilebilsin
    if (!file) return;
    this.importing = true;
    const form = new FormData();
    form.append("file", file);
    const res = await this.nucleusService.postExcel<any>(`/api/ContentCampaigns/${this.campaignId}/share-links/import`, form);
    this.importing = false;
    if (!res.isError) {
      const r = res.content || {};
      const extra = `${r.notFound ? ` · ${r.notFound} influencer bulunamadı` : ""}${r.skipped ? ` · ${r.skipped} satır atlandı` : ""}`;
      this.swalToast(4000, "success", `${r.imported} paylaşım linki yüklendi${extra}`);
      this.load();
    } else {
      this.swalToast(2500, "error", "Excel yüklenemedi");
    }
  }

  statusText(s: number): string {
    return ["Kayıt", "İçerik Yüklendi", "Revizyon", "Onaylandı", "Yayınlandı", "İstatistik"][s] || "?";
  }
  statusColor(s: number): string {
    return ["grey", "blue", "orange", "green", "purple", "teal"][s] || "grey";
  }
  typeText(t: number): string {
    return ["Taslak", "Yayın", "İstatistik"][t] || "?";
  }
  isVideo(url: string): boolean {
    return /\.(mp4|mov|webm|m4v)(\?|$)/i.test(url || "");
  }
  isUrl(v: string): boolean {
    return /^https?:\/\//i.test(v || "");
  }
  igLabel(v: string): string {
    const m = /instagram\.com\/([A-Za-z0-9._]+)/i.exec(v || "");
    return m ? "@" + m[1] : v;
  }
  openRow(item: any) {
    this.row = item;
    this.selected = (item.submissions && item.submissions.length) ? item.submissions[item.submissions.length - 1] : null;
    this.rowDialog = true;
  }
  groupedSubmissions(item: any): any[] {
    const subs = item.submissions || [];
    return [0, 1, 2]
      .map((type) => ({ type, items: subs.filter((s: any) => s.type === type) }))
      .filter((g) => g.items.length);
  }

  async approve(item: any) {
    const r = await this.swalConfirm("İçerik onaylansın ve influencer'a mail gönderilsin mi?");
    if (!(r as any).value) return;
    const res = await this.nucleusService.post<any>(`/api/ContentCampaigns/${this.campaignId}/influencers/${item.id}/approve`, {});
    if (!res.isError) {
      this.swalToast(2000, "success", "Onaylandı, mail gönderildi");
      this.rowDialog = false;
      this.load();
    } else {
      this.swalToast(2500, "error", "İşlem başarısız");
    }
  }

  portalLink(item: any): string {
    // Panel hangi adreste açıksa portal da orada; env (localhost) değerine güvenme.
    const base = window.location.origin.replace(/\/$/, "");
    return `${base}/portal/${item.accessToken}`;
  }

  async copyLink(item: any) {
    const link = this.portalLink(item);
    try {
      await navigator.clipboard.writeText(link);
      this.swalToast(1500, "success", "Özel link kopyalandı");
    } catch {
      // Pano API'si yoksa (http/eski tarayıcı) fallback.
      const ta = document.createElement("textarea");
      ta.value = link;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      this.swalToast(1500, "success", "Özel link kopyalandı");
    }
  }

  async changeStatus(item: any, status: number) {
    if (status === item.status) return;
    const r = await this.swalConfirm(`Durum "${this.statusText(status)}" olarak güncellensin mi?`);
    if (!(r as any).value) return;
    const res = await this.nucleusService.post<any>(
      `/api/ContentCampaigns/${this.campaignId}/influencers/${item.id}/status`,
      { status }
    );
    if (!res.isError) {
      this.swalToast(1500, "success", "Durum güncellendi");
      await this.fetchData();
      const fresh = this.items.find((x) => x.id === item.id);
      if (fresh) this.row = fresh;
    } else {
      this.swalToast(2500, "error", "Durum güncellenemedi");
    }
  }

  async deleteSubmission(s: any) {
    const r = await this.swalConfirm("Bu dosya kalıcı olarak silinecek. Emin misiniz?");
    if (!(r as any).value) return;
    const res = await this.nucleusService.delete(
      `/api/ContentCampaigns/${this.campaignId}/influencers/${this.row.id}/submissions/${s.id}`
    );
    if (!res.isError) {
      this.swalToast(1500, "success", "Dosya silindi");
      await this.fetchData();
      const fresh = this.items.find((x) => x.id === this.row.id);
      if (fresh) {
        this.row = fresh;
        if (this.selected && this.selected.id === s.id) {
          this.selected = (fresh.submissions && fresh.submissions.length)
            ? fresh.submissions[fresh.submissions.length - 1] : null;
        }
      }
    } else {
      this.swalToast(2500, "error", "Dosya silinemedi");
    }
  }

  openRevision(item: any) {
    this.current = item;
    this.revNote = "";
    this.rowDialog = false;
    this.revDialog = true;
  }

  async sendRevision() {
    this.saving = true;
    const res = await this.nucleusService.post<any>(
      `/api/ContentCampaigns/${this.campaignId}/influencers/${this.current.id}/revision`,
      { note: this.revNote }
    );
    this.saving = false;
    if (!res.isError) {
      this.swalToast(2000, "success", "Revizyon talebi gönderildi");
      this.revDialog = false;
      this.load();
    }
  }

  exportExcel() {
    this.openDownload(`/api/ContentCampaigns/${this.campaignId}/export`);
  }

  downloadZip(influencerId?: string) {
    const url = influencerId
      ? `/api/ContentCampaigns/${this.campaignId}/influencers/${influencerId}/download`
      : `/api/ContentCampaigns/${this.campaignId}/download`;
    this.openDownload(url);
  }

  openDownload(url: string) {
    const link = document.createElement("a");
    link.href = this.nucleus.baseApiUrl + url;
    link.target = "_blank";
    link.click();
  }
}
</script>

<style scoped>
.preview-thumb {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  background: #000;
  display: block;
}
.preview-thumb:hover {
  border-color: #6d28d9;
}
.thumb-pick {
  position: relative;
  width: 84px;
  height: 84px;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  overflow: hidden;
  cursor: pointer;
  background: #000;
  transition: border-color 0.15s;
}
.thumb-del {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.55) !important;
  opacity: 0;
  transition: opacity 0.15s;
}
.thumb-pick:hover .thumb-del {
  opacity: 1;
}
.thumb-pick:hover {
  border-color: #b794f4;
}
.thumb-pick--active {
  border-color: #6d28d9;
}
.thumb-pick img,
.thumb-pick video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.preview-pane {
  background: #0b0b0b;
  border-radius: 12px;
  min-height: 320px;
  max-height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.preview-pane img,
.preview-pane video {
  max-width: 100%;
  max-height: 65vh;
  object-fit: contain;
}
</style>
